module.exports = __webpack_public_path__ + "img/CellCycle-OVCA_10X_WTA.67484eab.png";